// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUsPage__box--PyJh {
    border: 1px solid var(--obscure-color);
    border-radius: 6px;
    padding: 24px;
    color: var(--secondary-color);
}

    .AboutUsPage__box--PyJh > ul {
        display: grid;
        grid-template-rows: auto;
        grid-gap: 16px;
    }

    @media screen and (min-width: 1024px) {

    .AboutUsPage__box--PyJh > ul {
            grid-template-columns: 1fr 1fr
    }
        }

    .AboutUsPage__box--PyJh > ul > li {
            display: grid;
            grid-template-columns: 20px auto;
            grid-gap: 4px;
        }

    .AboutUsPage__box--PyJh > ul > li > svg {
                width: 20px;
                height: 20px;
            }

    .AboutUsPage__box--PyJh > ul > li > span {
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
            }

    .AboutUsPage__box--PyJh > ul > li > span > strong {
                    font-weight: 700;
                }

.AboutUsPage__title--_oco {
    font-size: 26px;
    font-weight: 700;
    line-height: 34px;
    margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/pages/AboutUsPage/AboutUsPage.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,6BAA6B;AAgCjC;;IA9BI;QACI,aAAa;QACb,wBAAwB;QACxB,cAAc;IA0BlB;;IAxBI;;IALJ;YAMQ;IAuBR;QAtBI;;IAEA;YACI,aAAa;YACb,gCAAgC;YAChC,aAAa;QAgBjB;;IAdI;gBACI,WAAW;gBACX,YAAY;YAChB;;IAEA;gBACI,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;YAKrB;;IAHI;oBACI,gBAAgB;gBACpB;;AAMhB;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":[".box {\n    border: 1px solid var(--obscure-color);\n    border-radius: 6px;\n    padding: 24px;\n    color: var(--secondary-color);\n\n    > ul {\n        display: grid;\n        grid-template-rows: auto;\n        grid-gap: 16px;\n\n        @media (--large) {\n            grid-template-columns: 1fr 1fr;\n        }\n\n        > li {\n            display: grid;\n            grid-template-columns: 20px auto;\n            grid-gap: 4px;\n\n            > svg {\n                width: 20px;\n                height: 20px;\n            }\n\n            > span {\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 20px;\n\n                > strong {\n                    font-weight: 700;\n                }\n            }\n        }\n    }\n}\n\n.title {\n    font-size: 26px;\n    font-weight: 700;\n    line-height: 34px;\n    margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `AboutUsPage__box--PyJh`,
	"title": `AboutUsPage__title--_oco`
};
export default ___CSS_LOADER_EXPORT___;
